module.exports = __webpack_public_path__ + "static/logo-f255ad6b0c47b57e209f926e2aa7e036.png";